import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'
import useWindowSize from 'components/util/useWindowSize'

const options = [
  {
    description:
      'RESTful, secure, and well-documented. Build around Python, Java, Node.js or your preferred stack.',
    title: 'API Access',
  },
  {
    description:
      'No-code solution to manage client accounts, subscriptions, and reports.',
    title: 'Partner Dashboard',
  },
  {
    description:
      'Use both the dashboard and API together for maximum flexibility.',
    title: 'Hybrid Deployments',
  },
]

const SeamlessIntegration = () => {
  const size = useWindowSize()
  return (
    <LeftRobotCard
      image={{
        alt: 'Robot middle cut for seamless integration',
        desktop: {
          dimensions: {
            height: 605,
            width: 811,
          },
          src: '/images/new/robot-middle-cut.png',
        },
        mobile: {
          dimensions: {
            height: 897,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '40%' : '100%'}
      imageStyle={{
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'right',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-2 px-4 pb-5 pe-lg-27 py-lg-12 pb-14 mt-n16 mt-lg-0'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105 mb-5'>
          Seamless Integration Options
        </h3>
        <span className='fs-20 fw-semibold lh-119 d-block d-lg-none'>
          Deliver registered address services at scale—tailored for Australian
          partners.
        </span>
        <div className='d-flex flex-column gap-7'>
          {options.map((option) => (
            <div key={option.title}>
              <h4 className='fs-fluid-16-24'>{option.title}</h4>
              <span className='fs-fluid-16-20 fw-semibold color-grey5'>
                {option.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default SeamlessIntegration
